import React, {Component} from 'react';
import {ListGroup, ListGroupItem} from "reactstrap";
import {text} from "@fortawesome/fontawesome";

export class TreeVisualization extends Component<ITreeVisualizationProps, {}> {

  renderAvid(avid: IAvid) {
    const {AvidsList} = this.props;
    let isSelected = false;
    let isDisabled = false;

    const avidFromList = AvidsList.find((avidFromList) => avidFromList.id == avid.id);
    if (avidFromList) {
      isSelected = avidFromList.state.selected;
      isDisabled = !isSelected && avidFromList.children.length > 0;
    }

    return (
        <li key={`avid-${avid.id}`} className={((isSelected || isDisabled) ? 'list-group-item avid' : 'hide')}>
          <span className={(isSelected ? '' : (isDisabled ? 'text-muted' : 'hide'))} onClick={() => this.props.setDefaultAvid(avid)} style={{cursor: 'pointer'}}>{avid.text}</span>
          {avid.children.length > 0 &&
          <ul className={'list-group-flush'}>
            {/*<hr/>*/}
            {
              avid.children.map((childAvid) => {
                return(
                  this.renderAvid(childAvid)
                );
              })
            }
          </ul>
          }
        </li>
    );
  }
  render() {
    const {AvidsList, avidsGroupedByDistance} = this.props;
    if (avidsGroupedByDistance && avidsGroupedByDistance[0]) {
      return (
        <ul className='list-group'>
            {
              avidsGroupedByDistance[0].map((avid) => {
                return (
                  this.renderAvid(avid)
                )
              })
            }
          </ul>
      );
    }
    else {
      return (
        <div>

        </div>
      );
    }
  }
}